import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Box, Image as ImageDSR, Optional } from '@honda-canada/design-system-react';
import ImageNotFound from './ImageNotFound';
import Link from '../../RoutableSitecoreLink';
import themeStyles from '../styles/Card.styles';
const ImageNavLink = themeStyles.apply(Link, 'CardLink');
const ImageNav = themeStyles.apply(Box, 'CardImage');
const ImageContainer = themeStyles.apply(Box, 'ImageContainer');
const Image = (props) => {
    const { src, alt, placeholder, cta } = props;
    const { href, linktype, target, label, gtmEvent, params } = cta || {};
    const searchParams = new URLSearchParams(params);
    const ImageWrapper = href ? ImageNavLink : ImageNav;
    return (_jsxs(ImageWrapper, { tabIndex: "0", "data-testid": "cy-uni-card-image", field: {
            value: {
                linktype,
                href,
                target,
                querystring: searchParams,
            },
        }, ariaLabel: label || alt, onClick: gtmEvent, children: [_jsx(Optional, { when: src, children: _jsx(ImageContainer, { children: _jsx(ImageDSR, { src: src, alt: alt }) }) }), _jsx(Optional, { when: !src, children: _jsx(ImageNotFound, { altTextContent: placeholder }) })] }));
};
export default Image;
